import { allFrequencies, oneTime } from '../constants';
var getTransferFrequency = function (frequencyProp) {
    var _a;
    return (_a = allFrequencies.find(function (frequency) { return frequency.value === frequencyProp; })) !== null && _a !== void 0 ? _a : oneTime;
};
export default getTransferFrequency;
//# sourceMappingURL=getTransferFrequency.js.map